import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerStrianoSW } from "@/pwa/registerSW";

// GPS e PWA richiedono https: forza il redirect se aperto in http
if (window.location.protocol === "http:" && !/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
  window.location.replace(window.location.href.replace(/^http:/, "https:"));
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Registra Service Worker PWA (produzione / preview deployato)
registerStrianoSW();
